
import { defineComponent, ref, onMounted, nextTick } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import * as Yup from "yup";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { Actions } from "@/store/enums/StoreEnums";
import { PasswordMeterComponent } from "@/assets/ts/components";

export default defineComponent({
  name: "sign-up",
  components: {
    Field,
    Form,
    ErrorMessage,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const loading = ref<boolean>(false);
    const submitButton = ref<HTMLButtonElement | null>(null);
    const googleLogin = () => {
      location.replace(
        process.env.VUE_APP_BASE_URL + process.env.VUE_APP_GOOGLE_LOGIN_URL
      );
    };
    const linkedInLogin = () => {
      location.replace(
        process.env.VUE_APP_BASE_URL + process.env.VUE_APP_LINKEDIN_LOGIN_URL
      );
    };
    const registration = Yup.object().shape({
      firstName: Yup.string().required().label("Name"),
      lastName: Yup.string().required().label("Surname"),
      email: Yup.string().min(4).required().email().label("Email"),
      password: Yup.string().required().label("Password"),
      password_confirmation: Yup.string()
        .required()
        .oneOf([Yup.ref("password"), null], "Passwords must match")
        .label("Password Confirmation"),
    });

    onMounted(() => {
      nextTick(() => {
        PasswordMeterComponent.bootstrap();
      });
    });

    const onSubmitRegister = (values) => {
      loading.value = true;
      store.dispatch(Actions.LOGOUT);

      // eslint-disable-next-line
      submitButton.value!.disabled = true;

      // Activate indicator
      submitButton.value?.setAttribute("data-kt-indicator", "on");

      console.log({ values });

      store
        .dispatch(Actions.SIGNUP, values)
        .then((res) => {
          if (res !== true) throw new Error();
          loading.value = false;
          store.commit("setAlert", {
            message: "Success",
            subMessage: "You have successfully created a new account!",
            variant: "primary",
            duration: 4000,
            show: true,
          });
          setTimeout(() => {
            router.push({ name: "dashboard" });
          }, 2000);
        })
        .catch(() => {
          loading.value = false;
          const error = store.getters.getErrors;

          store.commit("setAlert", {
            message: "Error",
            subMessage: error,
            variant: "danger",
            duration: 4000,
            show: true,
          });
        });

      submitButton.value?.removeAttribute("data-kt-indicator");
      // eslint-disable-next-line
      submitButton.value!.disabled = false;
    };

    return {
      loading,
      registration,
      onSubmitRegister,
      submitButton,
      googleLogin,
      linkedInLogin,
    };
  },
});
